const { getOffsetTop } = window.BAO.Utils

class InstagramScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveGrid()
  }

  moveGrid () {
    if (!this.offsetHeight) return

    const imageEls = this.querySelectorAll('.fs-entry-container')

    const amountToMoveX = window.BAO.MediaBreakpoints.isMd ? 200 : 100
    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this) - window.innerHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.lastKnownY <= elementStartPoint) {
      imageEls.forEach((imageEl) => {
        imageEl.style.transform = `translate3d(${amountToMoveX / 2}px, 0px, 0px)`
      })

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      imageEls.forEach((imageEl) => {
        imageEl.style.transform = `translate3d(${amountToMoveX / -2}px, 0px, 0px)`
      })

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    imageEls.forEach((imageEl, index) => {
      const scrollYAsAPercentageOfJourney =
        index < 4 && !window.BAO.MediaBreakpoints.isSm
          ? 1 - (this.lastKnownY - elementStartPoint) / totalScrollAmount
          : (this.lastKnownY - elementStartPoint) / totalScrollAmount

      const transformAmountX =
        amountToMoveX * scrollYAsAPercentageOfJourney - amountToMoveX / 2

      imageEl.style.transform = `translate3d(${transformAmountX}px, 0px, 0px)`
    })
  }
}

if (!customElements.get('instagram-scroll')) {
  customElements.define('instagram-scroll', InstagramScroll)
}
